import HttpService from "./htttp.service";

class LeaseInvoiceService {
    getList = async(payload) => {
        const token = localStorage.getItem("token");
        const getListEndPoint = "properties";
        return await HttpService.get(getListEndPoint, payload, token);
    }
    getPropertyLeasesList = async(payload, id) => {
        const token = localStorage.getItem("token");
        const getListEndPoint = "properties/" + id + "/leases";
        return await HttpService.get(getListEndPoint, payload, token);
    }
    getPropertyLeasesExcel = async(payload, id) => {
        const token = localStorage.getItem("token");
        const getListEndPoint = "properties/" + id + "/leases";
        // console.log(getListEndPoint, payload);
        return await HttpService.get(getListEndPoint, payload, token);
    };

    getInvoiceList = async(payload) => {
        const token = localStorage.getItem("token");
        const getListEndPoint = "invoices";
        return await HttpService.get(getListEndPoint, payload, token);
    }

    getInvoiceDetails = async(id) => {
        const token = localStorage.getItem("token");
        const getInvoiceDetailsEndPoint = "invoices/" + id;
        return await HttpService.get(getInvoiceDetailsEndPoint, {}, token);
    }
    updateCustomInvoice = async(payload) => {
        const token = localStorage.getItem("");
        const updateCustomInvoiceEndpoint = "invoices/update-custom/" + payload.invoice_id;
        return await HttpService.post(updateCustomInvoiceEndpoint, payload, token, false);
    }

    duplicateLeaseInvoice = async (payload) => {
        const token = localStorage.getItem("token");
        const duplicateInvoiceEndpoint = "invoices/duplicate/" + payload.invoice_id;
        return await HttpService.post(duplicateInvoiceEndpoint, payload, token, false);
    };
}

export default new LeaseInvoiceService();
